export default "__VITE_ASSET__72678966__"